import { useTranslation } from 'react-i18next';

const MODULES = ['all', 'bibliography', 'bibliography_edit', 'scholar', 'organization', 'teaching_material', 'research_tool', 'broader_engagement', 'whats_new'];

function fmtDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

export default function SubmissionsList({ items, filter, onFilterChange, selectedKey, onSelect }) {
  const { t } = useTranslation();

  const counts = items.reduce((acc, item) => {
    acc[item.module] = (acc[item.module] ?? 0) + 1;
    return acc;
  }, {});

  const filtered = filter === 'all' ? items : items.filter((i) => i.module === filter);

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-2">
        {MODULES.map((m) => {
          const count = m === 'all' ? items.length : counts[m] ?? 0;
          if (m !== 'all' && count === 0) return null;
          return (
            <button
              key={m}
              type="button"
              onClick={() => onFilterChange(m)}
              className={`flex items-center gap-2 rounded-full border px-3 py-1 text-xs uppercase tracking-[0.1em] transition ${
                filter === m
                  ? 'border-gold/60 bg-navy-mid/60 text-gold-light'
                  : 'border-white/10 bg-navy-deep/40 text-ink-secondary hover:border-gold/30'
              }`}
            >
              {t(`admin.modules.${m}`)}
              <span className="rounded-full bg-navy-deep/60 px-1.5 text-[0.7rem] text-ink-muted">
                {count}
              </span>
            </button>
          );
        })}
      </div>

      {filtered.length === 0 ? (
        <p className="rounded-lg border border-white/10 bg-navy-base/40 p-10 text-center text-ink-secondary">
          {t('admin.queueEmpty')}
        </p>
      ) : (
        <ul className="flex flex-col gap-2">
          {filtered.map((item) => {
            const key = `${item.module}:${item.id}`;
            const active = selectedKey === key;
            return (
              <li key={key}>
                <button
                  type="button"
                  onClick={() => onSelect(item)}
                  className={`flex w-full items-start justify-between gap-4 rounded-lg border px-4 py-3 text-left transition ${
                    active
                      ? 'border-gold/50 bg-navy-mid/50'
                      : 'border-white/10 bg-navy-base/40 hover:border-gold/30'
                  }`}
                >
                  <div className="min-w-0">
                    <div className="text-[0.7rem] font-semibold uppercase tracking-[0.15em] text-gold">
                      {t(`admin.modules.${item.module}`)}
                    </div>
                    <div className="mt-0.5 line-clamp-2 font-serif text-base text-cream">
                      {item.title || t('admin.untitled')}
                    </div>
                    {item.module === 'bibliography' && item.authors?.length > 0 && (
                      <div className="mt-0.5 line-clamp-1 text-xs text-ink-secondary">
                        {item.authors.join('; ')}
                      </div>
                    )}
                  </div>
                  <span className="shrink-0 text-[0.7rem] text-ink-muted">
                    {fmtDate(item.created_at)}
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
